"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3756],{

/***/ 58085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ok": function() { return /* binding */ selectRecommendDiscountSetting; },
/* harmony export */   "l6": function() { return /* binding */ setRecommendDiscountEnabled; }
/* harmony export */ });
/* unused harmony export featureToggleSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const featureToggleSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "featureToggle",
    initialState: {
        recommendDiscount: {
            enable: false,
            loaded: false
        }
    },
    reducers: {
        setRecommendDiscountEnabled: (state, action)=>{
            state.recommendDiscount = {
                enable: action.payload,
                loaded: true
            };
        }
    }
});
const selectRecommendDiscountSetting = (state)=>state.featureToggle.recommendDiscount;
const { setRecommendDiscountEnabled  } = featureToggleSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (featureToggleSlice.reducer);


/***/ }),

/***/ 21367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "py": function() { return /* binding */ selectRehydrated; }
/* harmony export */ });
/* unused harmony export persistor */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8206);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(79036);
/* harmony import */ var redux_persist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97568);
/* harmony import */ var redux_persist_lib_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76734);
/* harmony import */ var redux_persist_transform_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38551);
/* harmony import */ var _bookForm_bookFormSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48068);
/* harmony import */ var _now_nowSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46756);
/* harmony import */ var _webview_webviewSlice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86377);
/* harmony import */ var _utm_utmSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39166);
/* harmony import */ var _selfConstruct_selfConstructSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67030);
/* harmony import */ var _cache_cacheSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24363);
/* harmony import */ var _pageLoad_pageLoadSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21095);
/* harmony import */ var _syDealCustomerVerify_syDealCustomerVerifySlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92852);
/* harmony import */ var _sid_sidSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34143);
/* harmony import */ var _featureToggle_featureToggleSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58085);
/* harmony import */ var _toast_toastSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47092);
/* harmony import */ var _selfConstructBookForm_selfConstructFormSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30587);
















const syDealCustomerVeiryFilter = (0,redux_persist_transform_filter__WEBPACK_IMPORTED_MODULE_2__/* .createFilter */ .cj)("syDealCustomerVerify", [
    "lastVerifyDate",
    "stopRemind",
    "showVerifyEntrance"
]);
const cacheFilter = (0,redux_persist_transform_filter__WEBPACK_IMPORTED_MODULE_2__/* .createFilter */ .cj)("cache", [
    "isFillUserInfoModalChecked",
    "authFromLocalbondChecked",
    "searchRecords"
]);
const persistConfig = {
    key: "root",
    version: 1,
    storage: redux_persist_lib_storage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    whitelist: [
        "bookForm",
        "cache",
        "syDealCustomerVerify"
    ],
    transforms: [
        cacheFilter,
        syDealCustomerVeiryFilter
    ]
};
const rootReducer = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_15__/* .combineReducers */ .UY)({
    bookForm: _bookForm_bookFormSlice__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP,
    selfConstructForm: _selfConstructBookForm_selfConstructFormSlice__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP,
    now: _now_nowSlice__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP,
    webview: _webview_webviewSlice__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP,
    utm: _utm_utmSlice__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP,
    selfConstruct: _selfConstruct_selfConstructSlice__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,
    cache: _cache_cacheSlice__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP,
    pageLoad: _pageLoad_pageLoadSlice__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP,
    syDealCustomerVerify: _syDealCustomerVerify_syDealCustomerVerifySlice__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP,
    sid: _sid_sidSlice__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP,
    featureToggle: _featureToggle_featureToggleSlice__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP,
    toast: _toast_toastSlice__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP
});
const persistedReducer = (0,redux_persist__WEBPACK_IMPORTED_MODULE_0__.persistReducer)(persistConfig, rootReducer);
const store = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_16__/* .configureStore */ .xC)({
    reducer: persistedReducer,
    devTolls: "beta" !== "prod",
    middleware: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_16__/* .getDefaultMiddleware */ .Bx)({
        serializableCheck: {
            ignoredActions: [
                redux_persist__WEBPACK_IMPORTED_MODULE_0__.FLUSH,
                redux_persist__WEBPACK_IMPORTED_MODULE_0__.REHYDRATE,
                redux_persist__WEBPACK_IMPORTED_MODULE_0__.PAUSE,
                redux_persist__WEBPACK_IMPORTED_MODULE_0__.PERSIST,
                redux_persist__WEBPACK_IMPORTED_MODULE_0__.PURGE,
                redux_persist__WEBPACK_IMPORTED_MODULE_0__.REGISTER
            ]
        }
    })
});
/* harmony default export */ __webpack_exports__["ZP"] = (store);
const persistor = (0,redux_persist__WEBPACK_IMPORTED_MODULE_0__.persistStore)(store);
const selectRehydrated = (state)=>{
    var _state__persist;
    return state === null || state === void 0 ? void 0 : (_state__persist = state._persist) === null || _state__persist === void 0 ? void 0 : _state__persist.rehydrated;
};


/***/ }),

/***/ 46756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J5": function() { return /* binding */ setNow; },
/* harmony export */   "jI": function() { return /* binding */ selectNow; }
/* harmony export */ });
/* unused harmony export nowSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const nowSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "now",
    initialState: null,
    reducers: {
        setNow: (state, action)=>action.payload
    }
});
const selectNow = (state)=>state.now;
const { setNow  } = nowSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (nowSlice.reducer);


/***/ }),

/***/ 21095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ setSelfConstructParamsInitialized; },
/* harmony export */   "De": function() { return /* binding */ setEncryptedUserIdReady; },
/* harmony export */   "KQ": function() { return /* binding */ selectPageLoad; },
/* harmony export */   "PA": function() { return /* binding */ setEncryptedPhone; },
/* harmony export */   "b7": function() { return /* binding */ setEncryptedPhoneReady; },
/* harmony export */   "cW": function() { return /* binding */ setNavbarClicked; },
/* harmony export */   "gG": function() { return /* binding */ setPageLoadAuthReadyInitialized; },
/* harmony export */   "gt": function() { return /* binding */ setEncryptedUserId; },
/* harmony export */   "pG": function() { return /* binding */ selectEnctyptedUserId; },
/* harmony export */   "xg": function() { return /* binding */ selectNavbarClicked; }
/* harmony export */ });
/* unused harmony export pageLoadSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const pageLoadSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "pageLoad",
    initialState: {
        // 紀錄進入網站第一個頁面的初始化是否已執行，
        // 該初始化只會在使用者資料準備好後執行
        authReadyInitialized: false,
        // 儲存加密後的user id，用於傳送firebase event
        encryptedUserId: {
            value: "",
            isReady: false
        },
        // 儲存加密後的手機號碼，用於防止重複呼叫加密API
        encryptedPhone: {
            value: "",
            isReady: false
        },
        // 自建單參數設定
        selfConstructParamsInitialized: false,
        // 判斷navbar點擊狀態
        navbarClicked: false
    },
    reducers: {
        setPageLoadAuthReadyInitialized: (state, action)=>{
            state.authReadyInitialized = action.payload;
        },
        setEncryptedUserId: (state, action)=>{
            state.encryptedUserId.value = action.payload;
            state.encryptedUserId.isReady = true;
        },
        setEncryptedUserIdReady: (state, action)=>{
            state.encryptedUserId.isReady = action.payload;
        },
        setEncryptedPhone: (state, action)=>{
            state.encryptedPhone.value = action.payload;
            state.encryptedPhone.isReady = true;
        },
        setEncryptedPhoneReady: (state, action)=>{
            state.encryptedPhone.isReady = action.payload;
        },
        setSelfConstructParamsInitialized: (state, action)=>{
            state.selfConstructParamsInitialized = action.payload;
        },
        setNavbarClicked: (state, action)=>{
            state.navbarClicked = action.payload;
        }
    }
});
const selectPageLoad = (state)=>state.pageLoad;
const selectEnctyptedUserId = (state)=>state.pageLoad.encryptedUserId;
const selectNavbarClicked = (state)=>state.pageLoad.navbarClicked;
const { setPageLoadAuthReadyInitialized , setEncryptedUserId , setEncryptedUserIdReady , setEncryptedPhone , setEncryptedPhoneReady , setSelfConstructParamsInitialized , setNavbarClicked  } = pageLoadSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (pageLoadSlice.reducer);


/***/ }),

/***/ 30587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ setStaffNumber; },
/* harmony export */   "$I": function() { return /* binding */ setIsSendNewOrderNotify; },
/* harmony export */   "BB": function() { return /* binding */ setCoupon; },
/* harmony export */   "EP": function() { return /* binding */ setContactName; },
/* harmony export */   "Fx": function() { return /* binding */ resetForm; },
/* harmony export */   "JW": function() { return /* binding */ setServiceClassificationDetail; },
/* harmony export */   "Kd": function() { return /* binding */ setCustomizations; },
/* harmony export */   "Mn": function() { return /* binding */ resetContactTime; },
/* harmony export */   "Ot": function() { return /* binding */ setVatNo; },
/* harmony export */   "Q_": function() { return /* binding */ updateMoveInAddressByIndex; },
/* harmony export */   "R_": function() { return /* binding */ removeMoveInAddressByIndex; },
/* harmony export */   "Sh": function() { return /* binding */ removeOneService; },
/* harmony export */   "U3": function() { return /* binding */ setNote; },
/* harmony export */   "V0": function() { return /* binding */ setIsCheckingBookedSession; },
/* harmony export */   "VP": function() { return /* binding */ setServiceCounty; },
/* harmony export */   "_E": function() { return /* binding */ setContactPhone; },
/* harmony export */   "bA": function() { return /* binding */ resetMoveInAddress; },
/* harmony export */   "bk": function() { return /* binding */ setObjectNo; },
/* harmony export */   "et": function() { return /* binding */ setVerificationPhone; },
/* harmony export */   "gn": function() { return /* binding */ setServiceDateTime; },
/* harmony export */   "gx": function() { return /* binding */ setServiceConfirmTime; },
/* harmony export */   "hq": function() { return /* binding */ addMoveInAddress; },
/* harmony export */   "jH": function() { return /* binding */ toggleService; },
/* harmony export */   "jJ": function() { return /* binding */ setServiceElevator; },
/* harmony export */   "jh": function() { return /* binding */ setSiteImages; },
/* harmony export */   "ky": function() { return /* binding */ selectSelfConstructForm; },
/* harmony export */   "lw": function() { return /* binding */ setServiceDetails; },
/* harmony export */   "nJ": function() { return /* binding */ setVatTitle; },
/* harmony export */   "ne": function() { return /* binding */ addOneService; },
/* harmony export */   "qE": function() { return /* binding */ setContactTime; },
/* harmony export */   "qh": function() { return /* binding */ resetServiceAddress; },
/* harmony export */   "si": function() { return /* binding */ setContactMail; },
/* harmony export */   "tM": function() { return /* binding */ setBookingReason; },
/* harmony export */   "tl": function() { return /* binding */ setPayment; },
/* harmony export */   "vO": function() { return /* binding */ setServiceDistrict; },
/* harmony export */   "wG": function() { return /* binding */ resetService; }
/* harmony export */ });
/* unused harmony exports selfConstructFormSlice, replaceMoveInAddress */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

/*
 * services and customizations field are normalized:
 *
 * services format example: {
 *  'id_1': { serviceId: 'id_1', count: 1 },
 *  'id_2': { serviceId: 'id_2', count: 3 },
 * }
 *
 * customizations format example: {
 *  'customization_id1': {
 *    'id_1': { itemId: 'id_1', count: 1 },
 *    'id_2': { itemId: 'id_2', count: 3 },
 *  },
 *  'customization_id2': {
 *    'id_1': { itemId: 'id_1', count: 1 },
 *    'id_2': { itemId: 'id_2', count: 3 },
 *  }
 * }
 */ const initialState = {
    staffNumber: "",
    objectNo: "",
    verificationPhone: "",
    customerContact: {
        name: "",
        phone: "",
        email: ""
    },
    selfBookingReason: "",
    serviceClassificationDetail: {},
    services: {},
    serviceAddress: {
        county: "",
        district: "",
        details: "",
        hasElevator: false
    },
    moveInAddress: [
        {
            type: "main"
        }
    ],
    serviceDateTime: {},
    serviceConfirmTime: {
        selectedDate: null,
        hour: "",
        minute: ""
    },
    isCheckingBookedSession: false,
    contactTime: "不拘(09:00-18:00)",
    payment: {
        method: "cash"
    },
    coupon: {},
    vatNo: "",
    vatTitle: "",
    customizations: {},
    siteImages: {},
    note: "",
    isSendNewOrderNotify: true
};
const selfConstructFormSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "selfConstructForm",
    initialState: initialState,
    reducers: {
        resetForm: (state, action)=>{
            return {
                ...initialState
            };
        },
        setStaffNumber: (state, action)=>{
            state.staffNumber = action.payload;
        },
        setObjectNo: (state, action)=>{
            state.objectNo = action.payload;
        },
        setVerificationPhone: (state, action)=>{
            state.verificationPhone = action.payload;
        },
        setContactName: (state, action)=>{
            state.customerContact.name = action.payload;
        },
        setContactPhone: (state, action)=>{
            state.customerContact.phone = action.payload;
        },
        setContactMail: (state, action)=>{
            state.customerContact.email = action.payload;
        },
        setBookingReason: (state, action)=>{
            state.selfBookingReason = action.payload;
        },
        // handle service modification
        setServiceClassificationDetail: (state, action)=>{
            state.serviceClassificationDetail = action.payload;
        },
        resetService: (state, action)=>{
            const { services: initService  } = initialState;
            state.services = initService;
        },
        addOneService: (state, action)=>{
            const servicePlan = action.payload;
            if (state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id]) {
                state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id].count += 1;
            } else {
                state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id] = {
                    serviceId: servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id,
                    count: 1
                };
            }
        },
        removeOneService: (state, action)=>{
            var _state_services_servicePlan__id;
            const servicePlan = action.payload;
            if (((_state_services_servicePlan__id = state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id]) === null || _state_services_servicePlan__id === void 0 ? void 0 : _state_services_servicePlan__id.count) <= 1) {
                delete state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id];
            } else {
                state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id].count -= 1;
            }
        },
        toggleService: (state, action)=>{
            const { servicePlan , isServiceSingle , inputType , crossSelect  } = action.payload;
            if (state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id]) {
                delete state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id];
            } else {
                if (inputType === "radio" || isServiceSingle || crossSelect) {
                    state.services = {
                        [servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id]: {
                            serviceId: servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id,
                            count: 1
                        }
                    };
                } else {
                    state.services[servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id] = {
                        serviceId: servicePlan === null || servicePlan === void 0 ? void 0 : servicePlan._id,
                        count: 1
                    };
                }
            }
        },
        // handle fill address data
        resetServiceAddress: (state, action)=>{
            const { serviceAddress: initServiceAddress  } = initialState;
            state.serviceAddress = initServiceAddress;
        },
        setServiceCounty: (state, action)=>{
            state.serviceAddress.county = action.payload;
        },
        setServiceDistrict: (state, action)=>{
            state.serviceAddress.district = action.payload;
        },
        setServiceDetails: (state, action)=>{
            state.serviceAddress.details = action.payload;
        },
        setServiceElevator: (state, action)=>{
            state.serviceAddress.hasElevator = action.payload;
        },
        // move in addresses control
        addMoveInAddress: (state, action)=>{
            state.moveInAddress.push({
                type: "others"
            });
        },
        removeMoveInAddressByIndex: (state, action)=>{
            state.moveInAddress.splice(action.payload, 1);
        },
        updateMoveInAddressByIndex: (state, action)=>{
            const { index , address  } = action.payload;
            state.moveInAddress = state.moveInAddress.map((addressInfo, idx)=>idx === index ? address : addressInfo);
        },
        replaceMoveInAddress: (state, action)=>{
            state.moveInAddress = action.payload;
        },
        resetMoveInAddress: (state, action)=>{
            const { moveInAddress: initMoveInAddress  } = initialState;
            state.moveInAddress = initMoveInAddress;
        },
        setServiceDateTime: (state, action)=>{
            state.serviceDateTime = action.payload;
        },
        setServiceConfirmTime: (state, action)=>{
            state.serviceConfirmTime = action.payload;
        },
        setIsCheckingBookedSession: (state, action)=>{
            state.isCheckingBookedSession = action.payload;
        },
        resetContactTime: (state, action)=>{
            const { contactTime: initContactTime  } = initialState;
            state.contactTime = initContactTime;
        },
        setContactTime: (state, action)=>{
            state.contactTime = action.payload;
        },
        setPayment: (state, action)=>{
            state.payment = action.payload;
        },
        setCoupon: (state, action)=>{
            state.coupon = action.payload;
        },
        setVatNo: (state, action)=>{
            state.vatNo = action.payload;
        },
        setVatTitle: (state, action)=>{
            state.vatTitle = action.payload;
        },
        setCustomizations: (state, action)=>{
            state.customizations = action.payload;
        },
        setSiteImages: (state, action)=>{
            state.siteImages = action.payload;
        },
        setNote: (state, action)=>{
            state.note = action.payload;
        },
        setIsSendNewOrderNotify: (state, action)=>{
            state.isSendNewOrderNotify = !state.isSendNewOrderNotify;
        }
    }
});
const selectSelfConstructForm = (state)=>state.selfConstructForm;
const { resetForm , setStaffNumber , setObjectNo , setVerificationPhone , setContactName , setContactPhone , setContactMail , setBookingReason , setServiceClassificationDetail , resetService , addOneService , removeOneService , toggleService , resetServiceAddress , setServiceCounty , setServiceDistrict , setServiceDetails , setServiceElevator , addMoveInAddress , removeMoveInAddressByIndex , updateMoveInAddressByIndex , replaceMoveInAddress , resetMoveInAddress , setServiceDateTime , setServiceConfirmTime , setIsCheckingBookedSession , resetContactTime , setContactTime , setPayment , setCoupon , setVatNo , setVatTitle , setCustomizations , setSiteImages , setNote , setIsSendNewOrderNotify  } = selfConstructFormSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (selfConstructFormSlice.reducer);


/***/ }),

/***/ 34143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FF": function() { return /* binding */ selectSIDInfo; },
/* harmony export */   "_S": function() { return /* binding */ sidSettled; },
/* harmony export */   "n8": function() { return /* binding */ initSIDToAgents; }
/* harmony export */ });
/* unused harmony export sidSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const sidSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "sid",
    initialState: {
        isSettled: false,
        sid: "",
        initSIDToAgents: false
    },
    reducers: {
        sidSettled: (state, action)=>{
            state.sid = action.payload;
            state.isSettled = true;
        },
        initSIDToAgents: (state, action)=>{
            state.initSIDToAgents = true;
        }
    }
});
const selectSIDInfo = (state)=>state.sid;
const { sidSettled , initSIDToAgents  } = sidSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (sidSlice.reducer);


/***/ }),

/***/ 92852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mg": function() { return /* binding */ setSyDealCustomerIdentity; },
/* harmony export */   "NX": function() { return /* binding */ clearSyDealCustomerVerify; },
/* harmony export */   "a1": function() { return /* binding */ syDealCustomerVerificationProcessed; },
/* harmony export */   "ev": function() { return /* binding */ stopRemindingSyDealCustomerVerify; },
/* harmony export */   "fl": function() { return /* binding */ setCheckVerificationInLsApp; },
/* harmony export */   "kU": function() { return /* binding */ closeSyDealCustomerIdentityInputModal; },
/* harmony export */   "ny": function() { return /* binding */ showSinyiCustomerVerifyEntrance; },
/* harmony export */   "pJ": function() { return /* binding */ selectShowSinyiCustomerVerifyEntrance; },
/* harmony export */   "qQ": function() { return /* binding */ selectSyDealCustomerIdentityInputModal; },
/* harmony export */   "qg": function() { return /* binding */ openSyDealCustomerIdentityInputModal; },
/* harmony export */   "wE": function() { return /* binding */ selectSyDealCustomerVerifyData; }
/* harmony export */ });
/* unused harmony export syDealCustomerVerifySlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79036);
/* harmony import */ var redux_persist__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97568);


const initialState = {
    processed: false,
    lastVerifyDate: "1970-01-01T00:00:00.000Z",
    stopRemind: false,
    identityInputModal: {
        open: false,
        identity: ""
    },
    showVerifyEntrance: false,
    checkVerificationInLsApp: false
};
const syDealCustomerVerifySlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSlice */ .oM)({
    name: "syDealCustomerVerify",
    initialState: initialState,
    reducers: {
        syDealCustomerVerificationProcessed: (state, action)=>{
            const date = action.payload;
            state.lastVerifyDate = date;
            state.processed = true;
        },
        stopRemindingSyDealCustomerVerify: (state, action)=>{
            state.stopRemind = true;
        },
        openSyDealCustomerIdentityInputModal: (state, action)=>{
            state.identityInputModal = {
                open: true,
                identity: ""
            };
        },
        closeSyDealCustomerIdentityInputModal: (state, action)=>{
            state.identityInputModal = {
                open: false,
                identity: ""
            };
        },
        setSyDealCustomerIdentity: (state, action)=>{
            state.identityInputModal.identity = action.payload;
        },
        showSinyiCustomerVerifyEntrance: (state, action)=>{
            state.showVerifyEntrance = action.payload;
        },
        setCheckVerificationInLsApp: (state, action)=>{
            state.checkVerificationInLsApp = action.payload;
        },
        clearSyDealCustomerVerify: (state, action)=>{
            return {
                ...initialState
            };
        }
    },
    extraReducers: (builder)=>{
        builder.addCase(redux_persist__WEBPACK_IMPORTED_MODULE_0__.REHYDRATE, (state, action)=>{
            var _action_payload;
            return {
                ...state,
                ...(_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.syDealCustomerVerify
            };
        });
    }
});
const selectSyDealCustomerVerifyData = (state)=>state.syDealCustomerVerify;
const selectSyDealCustomerIdentityInputModal = (state)=>state.syDealCustomerVerify.identityInputModal;
const selectShowSinyiCustomerVerifyEntrance = (state)=>state.syDealCustomerVerify.showVerifyEntrance;
const { syDealCustomerVerificationProcessed , stopRemindingSyDealCustomerVerify , openSyDealCustomerIdentityInputModal , closeSyDealCustomerIdentityInputModal , setSyDealCustomerIdentity , showSinyiCustomerVerifyEntrance , setCheckVerificationInLsApp , clearSyDealCustomerVerify  } = syDealCustomerVerifySlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (syDealCustomerVerifySlice.reducer);


/***/ }),

/***/ 47092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vr": function() { return /* binding */ selectToastSetting; },
/* harmony export */   "fz": function() { return /* binding */ setToast; }
/* harmony export */ });
/* unused harmony export toastSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const toastSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "toast",
    initialState: {
        toast: {
            open: false,
            message: ""
        }
    },
    reducers: {
        setToast: (state, action)=>{
            state.toast = {
                open: action.payload.open,
                message: action.payload.message
            };
        }
    }
});
const selectToastSetting = (state)=>state.toast;
const { setToast  } = toastSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (toastSlice.reducer);


/***/ }),

/***/ 39166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wi": function() { return /* binding */ setUtm; },
/* harmony export */   "vw": function() { return /* binding */ selectUtm; }
/* harmony export */ });
/* unused harmony export utmSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79036);

const utmSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
    name: "utm",
    initialState: {},
    reducers: {
        setUtm: (state, action)=>action.payload
    }
});
const selectUtm = (state)=>state.utm;
const { setUtm  } = utmSlice.actions;
/* harmony default export */ __webpack_exports__["ZP"] = (utmSlice.reducer);


/***/ }),

/***/ 93756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_withLivingSinyi; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/CookiesProvider.js
var CookiesProvider = __webpack_require__(44410);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./utils/auth/index.js
var auth = __webpack_require__(53130);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
// EXTERNAL MODULE: ./store/index.js
var store = __webpack_require__(21367);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./store/utm/utmSlice.js
var utmSlice = __webpack_require__(39166);
// EXTERNAL MODULE: ./store/selfConstruct/selfConstructSlice.js
var selfConstructSlice = __webpack_require__(67030);
// EXTERNAL MODULE: ./store/cache/cacheSlice.js
var cacheSlice = __webpack_require__(24363);
;// CONCATENATED MODULE: ./utils/webview.js
/*
 * Maintain webview flag, it repersent it's wrapped in which native webview,
 * or the web is just opened by regular browser.
 */ 









const WebviewDetector = (param)=>{
    let { children  } = param;
    // TODO: should detect both server side and client side
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        if (router.isReady) {
            const { webview , device , appVersion , osVersion , utm_source , utm_medium , utm_campaign , utm_term , utm_content , syStaffCode , additionalNote , serviceAdminNote , reservationCode , scUserId , gclid , pvid , preselect_vender  } = router.query;
            if (webview) {
                dispatch((0,webviewSlice/* setWebviewName */.NE)(webview));
                dispatch((0,webviewSlice/* setWebviewDevice */.E6)(device));
                dispatch((0,webviewSlice/* setWebviewAppVersion */.Cg)(appVersion));
                dispatch((0,webviewSlice/* setWebviewOsVersion */.es)(osVersion));
            }
            if (utm_source) {
                dispatch((0,utmSlice/* setUtm */.Wi)({
                    source: utm_source,
                    medium: utm_medium || "",
                    campaign: utm_campaign || "",
                    term: utm_term || "",
                    content: utm_content || ""
                }));
            } else if (gclid) {
                // 若是 Ｇoogle 廣告過來的，且沒有 utm_source，補上 utm_source
                dispatch((0,utmSlice/* setUtm */.Wi)({
                    source: "google",
                    medium: "cp"
                }));
            }
            if (syStaffCode) {
                dispatch((0,webviewSlice/* setSyStaffCode */.zL)(syStaffCode));
            }
            if (additionalNote) {
                dispatch((0,webviewSlice/* setAdditionalNote */.jT)(additionalNote));
            }
            if (serviceAdminNote) {
                dispatch((0,webviewSlice/* setServiceAdminNote */.A9)(serviceAdminNote));
            }
            if (reservationCode) {
                dispatch((0,selfConstructSlice/* setReservationCode */.FK)(reservationCode));
            }
            if (scUserId) {
                dispatch((0,selfConstructSlice/* setSelfConstructUserId */.XL)(scUserId));
            }
            if (pvid) {
                const venderIds = typeof pvid === "string" ? [
                    pvid
                ] : pvid;
                dispatch((0,webviewSlice/* setPriorityVenderIds */.P)(venderIds));
            }
            if (preselect_vender) {
                dispatch((0,cacheSlice/* setPreselectVender */.bE)(preselect_vender));
            }
            dispatch((0,webviewSlice/* webviewInitialized */.Fm)());
        }
    }, [
        router.isReady
    ]);
    const [nextRoute, setNextRoute] = (0,react.useState)("");
    const [nextRouteInfo, setNextRouteInfo] = (0,react.useState)({
        path: "",
        shallow: false
    });
    const webviewFromRedux = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const selfConstruct = (0,es/* useSelector */.v9)(selfConstructSlice/* selectSelfConstruct */.k$);
    const preselectVenderFromRedux = (0,es/* useSelector */.v9)(cacheSlice/* selectPreselectVender */.Wl);
    (0,react.useEffect)(()=>{
        if (!router.isReady) {
            return;
        }
        const handleRouteStart = (url, param)=>{
            let { shallow  } = param;
            var _webviewFromRedux_priorityVenderIds;
            let query = {};
            const [path, qs] = url.split("?");
            if (qs) {
                query = (0,lib.parse)(qs);
            }
            if (webviewFromRedux === null || webviewFromRedux === void 0 ? void 0 : webviewFromRedux.name) {
                query = {
                    ...query,
                    webview: webviewFromRedux.name,
                    device: webviewFromRedux.device,
                    appVersion: webviewFromRedux.appVersion,
                    osVersion: webviewFromRedux.osVersion
                };
            }
            if (webviewFromRedux === null || webviewFromRedux === void 0 ? void 0 : webviewFromRedux.syStaffCode) {
                query.syStaffCode = webviewFromRedux.syStaffCode;
            }
            if (webviewFromRedux === null || webviewFromRedux === void 0 ? void 0 : webviewFromRedux.additionalNote) {
                query.additionalNote = webviewFromRedux.additionalNote;
            }
            if (webviewFromRedux === null || webviewFromRedux === void 0 ? void 0 : webviewFromRedux.serviceAdminNote) {
                query.serviceAdminNote = webviewFromRedux.serviceAdminNote;
            }
            if (webviewFromRedux === null || webviewFromRedux === void 0 ? void 0 : (_webviewFromRedux_priorityVenderIds = webviewFromRedux.priorityVenderIds) === null || _webviewFromRedux_priorityVenderIds === void 0 ? void 0 : _webviewFromRedux_priorityVenderIds.length) {
                query.pvid = webviewFromRedux.priorityVenderIds;
            }
            if (selfConstruct === null || selfConstruct === void 0 ? void 0 : selfConstruct.reservationCode) {
                // 為了重新整理後還可以繼續對指定客戶繼續操作
                query.reservationCode = selfConstruct.reservationCode;
            }
            if (selfConstruct === null || selfConstruct === void 0 ? void 0 : selfConstruct.scUserId) {
                query.scUserId = selfConstruct.scUserId;
            }
            if (preselectVenderFromRedux) {
                query.preselect_vender = preselectVenderFromRedux;
            }
            if (!(0,isEmpty/* default */.Z)(query)) {
                setNextRouteInfo({
                    path: path + "?" + (0,lib.stringify)(query),
                    shallow
                });
                router.events.emit("routeChangeError");
                throw "cancelled route change";
            }
        };
        const onDestroy = ()=>{
            router.events.off("routeChangeStart", handleRouteStart);
        };
        if (nextRouteInfo.path) {
            router.push(nextRouteInfo.path, undefined, {
                shallow: nextRouteInfo.shallow
            });
            return onDestroy;
        }
        router.events.on("routeChangeStart", handleRouteStart);
        return onDestroy;
    }, [
        nextRouteInfo.path,
        webviewFromRedux,
        selfConstruct,
        preselectVenderFromRedux
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./utils/page-load/index.js


const DynamicPageLoadProcessor = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2290).then(__webpack_require__.bind(__webpack_require__, 52290)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52290)
            ]
    },
    ssr: false
});
const PageLoadInitializer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPageLoadProcessor, {})
        ]
    });
};
/* harmony default export */ var page_load = (PageLoadInitializer);

// EXTERNAL MODULE: ./node_modules/lodash-es/includes.js + 2 modules
var includes = __webpack_require__(19658);
;// CONCATENATED MODULE: ./components/common/OmnichatProvider/useOmnichatEnableListener.js





const routesPreventInitial = [
    "/login/vender-staff/line-bot",
    "/vender-staff/reservation/[reservationId]/upload-processing-images",
    "/album/[albumUrlId]",
    "/reservation/[reservationId]/[orderStatus]",
    "/self-construct-singlereservation",
    "/service/[identityCode]",
    "/service/[identityCode]/booking",
    "/service/[identityCode]/checkout",
    "/error",
    "/404",
    "/500"
];
const useOmnichatEnableListener = ()=>{
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const router = (0,next_router.useRouter)();
    const enabled = (0,react.useMemo)(()=>{
        if (router.isReady && webview.initialized && (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp") {
            // 如果是中華電信行銷頁則不初始化 Omnichat
            // TODO: 未來若類似需求越來越多則可改用陣列或其他方式管理
            const actualPath = router.asPath.split("?")[0];
            if (actualPath === "/olmkt/cht") return false;
            return !(0,includes/* default */.Z)(routesPreventInitial, router.pathname);
        } else {
            return false;
        }
    }, [
        router.isReady,
        webview === null || webview === void 0 ? void 0 : webview.initialized
    ]);
    return {
        enabled
    };
};

;// CONCATENATED MODULE: ./utils/hooks/useLCPDetector.js

/**
 * 偵測 LCP 的 Hook
 * @returns {boolean} lcpDetected - LCP 是否已完成
 */ const useLCPDetector = ()=>{
    const [lcpDetected, setLcpDetected] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (false) {}
        let observer = null;
        // 使用 PerformanceObserver 偵測 LCP
        if ("PerformanceObserver" in window) {
            let lastEntry = null;
            observer = new PerformanceObserver((list)=>{
                const entries = list.getEntries();
                lastEntry = entries[entries.length - 1];
            });
            try {
                observer.observe({
                    type: "largest-contentful-paint",
                    buffered: true
                });
            } catch (e) {
                console.warn("PerformanceObserver 不支援 LCP 偵測", e);
                if (observer) observer.disconnect();
                // 若瀏覽器不支援則 2.5 秒後設為 true
                setTimeout(()=>setLcpDetected(true), 2500);
            }
            // 2.5 秒後檢查是否有 lastEntry 並當作 LCP
            const checkTimer = setTimeout(()=>{
                if (lastEntry) {
                    setLcpDetected(true);
                    if (observer) observer.disconnect();
                }
            }, 2500);
            // Fallback: 如果 5 秒後還沒偵測到，強制設定為 true
            const fallbackTimer = setTimeout(()=>{
                setLcpDetected(true);
                if (observer) observer.disconnect();
            }, 5000);
            return ()=>{
                clearTimeout(checkTimer);
                clearTimeout(fallbackTimer);
                if (observer) observer.disconnect();
            };
        } else {
            // 不支援 PerformanceObserver 的瀏覽器，延遲 2.5 秒
            setTimeout(()=>setLcpDetected(true), 2500);
        }
    }, []);
    return lcpDetected;
};

;// CONCATENATED MODULE: ./components/common/OmnichatProvider/index.js




const OMNICHAT_ELEMENT_IDS = [
    "easychat-floating-button",
    "easychat-unread-badge",
    "easychat-close-btn",
    "easychat-chat-dialog"
];
const OmnichatProvider = (param)=>{
    let { children  } = param;
    const { enabled  } = useOmnichatEnableListener();
    const lcpDetected = useLCPDetector();
    const showOmnichatElements = ()=>{
        OMNICHAT_ELEMENT_IDS.forEach((id)=>{
            const el = document.getElementById(id);
            if (el) {
                el.style.display = "";
            }
        });
    };
    const hideOmnichatElements = ()=>{
        OMNICHAT_ELEMENT_IDS.forEach((id)=>{
            const el = document.getElementById(id);
            if (el) el.style.display = "none";
        });
    };
    (0,react.useEffect)(()=>{
        // 若元素已存在則根據 enabled 即時顯示或隱藏
        if (document.getElementById("omnichat-plugin")) {
            if (!enabled) {
                hideOmnichatElements();
            } else {
                showOmnichatElements();
            }
            return;
        }
        // 若元素不存在且未啟用則直接 return
        if (!enabled) return;
        // 只在 LCP 偵測完成時才載入
        if (!lcpDetected) return;
        const initOmnichat = ()=>{
            if (!document.getElementById("easychat-floating-button")) {
                const a = document.createElement("a");
                a.href = "javascript:;";
                a.id = "easychat-floating-button";
                // 固定在距離下方 24px、右側 20px
                a.style.position = "fixed";
                a.style.bottom = "24px";
                a.style.right = "20px";
                a.style.display = "none";
                const span = document.createElement("span");
                span.id = "easychat-unread-badge";
                span.style.display = "none";
                const d1 = document.createElement("div");
                d1.id = "easychat-close-btn";
                d1.className = "easychat-close-btn-close";
                d1.style.display = "none";
                const d2 = document.createElement("div");
                d2.id = "easychat-chat-dialog";
                d2.className = "easychat-chat-dialog-close";
                d2.style.display = "none";
                const ifrm = document.createElement("iframe");
                ifrm.id = "easychat-chat-dialog-iframe";
                ifrm.src = "https://client-chat.easychat.co/?appkey=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0ZWFtTmFtZSI6ImI0MTdiMmRlLTk4ZjctNDRmYS1hNThjLTQ5MzdhN2JkYTk0NSJ9.hRzln-HfuKQSg2M2liRl3YZB-t6BPGAj7bk4zA0Iz88&lang=zh-Hant";
                ifrm.style.width = "100%";
                ifrm.style.height = "100%";
                ifrm.setAttribute("frameBorder", "0");
                ifrm.setAttribute("scrolling", "yes");
                d2.appendChild(ifrm);
                document.body.appendChild(a);
                document.body.appendChild(span);
                document.body.appendChild(d1);
                document.body.appendChild(d2);
            }
            // 載入 script 後才顯示按鈕以避免 CLS
            const scriptURL = "https://chat-plugin.easychat.co/easychat.js";
            if (!document.getElementById("omnichat-plugin")) {
                const scriptTag = document.createElement("script");
                scriptTag.src = scriptURL;
                scriptTag.id = "omnichat-plugin";
                scriptTag.onload = ()=>{
                    showOmnichatElements();
                };
                document.body.appendChild(scriptTag);
            }
            // 按鈕點擊 GA
            const setupButtonListener = ()=>{
                const container = document.getElementById("easychat-floating-button");
                if (!container || container.dataset.listenerAttached) return;
                container.dataset.listenerAttached = "true";
                container.addEventListener("click", ()=>{
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "living_action",
                        living_event_name: "line@_click"
                    });
                });
            };
            setupButtonListener();
        };
        if (enabled) {
            initOmnichat();
        } else {
            hideOmnichatElements();
        }
    }, [
        lcpDetected,
        enabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var common_OmnichatProvider = (OmnichatProvider);

// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
;// CONCATENATED MODULE: ./components/common/ThirdPartyScriptsLoader/index.js



/**
 * 延遲載入第三方 script（目前只先延遲 GTM），等 LCP 完成後再執行
 */ const ThirdPartyScriptsLoader = ()=>{
    const lcpDetected = useLCPDetector();
    (0,react.useEffect)(()=>{
        if (!lcpDetected) return;
        // 載入 GTM
        const loadGTM = ()=>{
            window[constants/* GTM_DEFAULT_DATA_LAYER */.MH] = window[constants/* GTM_DEFAULT_DATA_LAYER */.MH] || [];
            window[constants/* GTM_DEFAULT_DATA_LAYER */.MH].push({
                "gtm.start": new Date().getTime(),
                event: "gtm.js"
            });
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtm.js?id=".concat(constants/* GOOGLE_TAG_MANAGER_KEY */.zL, "&l=").concat(constants/* GTM_DEFAULT_DATA_LAYER */.MH);
            document.head.appendChild(script);
        };
        loadGTM();
    }, [
        lcpDetected
    ]);
    return null;
};
/* harmony default export */ var common_ThirdPartyScriptsLoader = (ThirdPartyScriptsLoader);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Snackbar/Snackbar.js + 3 modules
var Snackbar = __webpack_require__(17155);
// EXTERNAL MODULE: ./store/toast/toastSlice.js
var toastSlice = __webpack_require__(47092);
;// CONCATENATED MODULE: ./components/common/GlobalToastWrapper/index.js




const GlobalToastWrapper = (param)=>{
    let { children  } = param;
    const { toast  } = (0,es/* useSelector */.v9)(toastSlice/* selectToastSetting */.Vr);
    const dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: toast === null || toast === void 0 ? void 0 : toast.open,
                autoHideDuration: 6000,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                message: toast === null || toast === void 0 ? void 0 : toast.message,
                onClose: ()=>dispatch((0,toastSlice/* setToast */.fz)({
                        open: false,
                        message: ""
                    }))
            }),
            children
        ]
    });
};
/* harmony default export */ var common_GlobalToastWrapper = (GlobalToastWrapper);

// EXTERNAL MODULE: ./utils/api/hooks/useLoginData.js
var useLoginData = __webpack_require__(68056);
;// CONCATENATED MODULE: ./components/common/SyDealCustomerVerifyProvider/index.js




const DynamicProcessingVerifyCheck = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9072), __webpack_require__.e(9477), __webpack_require__.e(5616), __webpack_require__.e(6541), __webpack_require__.e(988), __webpack_require__.e(5563), __webpack_require__.e(1930), __webpack_require__.e(486)]).then(__webpack_require__.bind(__webpack_require__, 70486)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(70486)
            ]
    },
    ssr: false
});
const SyDealCustomerVerifyProvider = (param)=>{
    let { children  } = param;
    const { me , appId , token , isLoading: isAuthLoading  } = (0,useLoginData/* useLoginData */.Q)();
    const [processingVerifyCheck, setProcessingVerifyCheck] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (isAuthLoading || !me) {
            return;
        }
        setProcessingVerifyCheck(true);
    }, [
        isAuthLoading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            processingVerifyCheck && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicProcessingVerifyCheck, {})
        ]
    });
};
/* harmony default export */ var common_SyDealCustomerVerifyProvider = (SyDealCustomerVerifyProvider);

;// CONCATENATED MODULE: ./utils/withLivingSinyi.js
/*
 * Higher order Component for pages
 */ 













const defaultOptions = {
    syDealCustomerVerify: true
};
const swrConfig = {
    fetcher: request/* lsGet */.UY
};
const withLivingSinyi = function(WrappedComponent) {
    let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const LivingSinyiHOC = (props)=>{
        (0,react.useEffect)(()=>{
            if ("serviceWorker" in navigator) {
                window.addEventListener("load", ()=>{
                    navigator.serviceWorker.register("/sw.js").then(()=>console.log("service worker registered")).catch((err)=>console.dir(err));
                });
            } else {
                console.log("service worker disabled");
            }
        }, []);
        const child = (0,react.useMemo)(()=>{
            const options = {
                ...defaultOptions,
                ...opts
            };
            let child = /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, {
                ...props
            });
            if (options.syDealCustomerVerify) {
                child = /*#__PURE__*/ (0,jsx_runtime.jsx)(common_SyDealCustomerVerifyProvider, {
                    children: child
                });
            }
            return child;
        }, [
            props,
            WrappedComponent,
            opts
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Provider */.zt, {
            store: store/* default */.ZP,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
                value: {
                    ...swrConfig,
                    fallback: props.swrFallback || {}
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesProvider/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebviewDetector, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth/* AuthProvider */.Ho, {
                            defaultToken: props.token,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_load, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ThirdPartyScriptsLoader, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_OmnichatProvider, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_GlobalToastWrapper, {
                                            children: child
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        });
    };
    return LivingSinyiHOC;
};
/* harmony default export */ var utils_withLivingSinyi = (withLivingSinyi);


/***/ })

}]);